module.exports = __webpack_public_path__ + "static/media/TotalPay.433f30b0.svg";